import { attendeeFetchData, attendeeDeleteData, attendeeSendData, attendeePutData } from "./index";

const eventQuizAPI = {
  fetch: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/exam`),
  send: (attendeeId, data) => attendeePutData(`/api/v2/attendees/${attendeeId}/exam`, data),
}

export default eventQuizAPI;